export const releaseNoteAllEn = [
  [
    {
      releaseDate: "2026-06-02T16:00",
      updatedDate: "2026-06-02T16:00",
      version: "12.0.0",
      introduction: "We are constantly working to improve your experience with our infoceanus tools. Here is a summary of some of our newest changes to connect:",
      conclusion: "We always value your feedback. If you have any suggestions for improvement or other feedback for our infoceanus tools, please send us an email at connect-support@jrcs.co.jp. Happy sailing!"
    },
    {
      title: "New features",
      descriptions: [
        "NEW! Custom Dashboard Page\nAdd up to 8 dashboards\nCan be made either public or private\nAdd desired components into a single page - Channel values, Trend charts (up to 4), Live Trend charts (up to 4)\nCustomize the layout according to your needs\nAdd free text label on any part of the dashboard",
      ],
      images: [
        require('./images/v12-0-0_fig1.png').default,
        require('./images/v12-0-0_fig2.png').default,
        require('./images/v12-0-0_fig3.png').default,
        require('./images/v12-0-0_fig4.png').default,
        require('./images/v12-0-0_fig5.png').default,
      ],
    },
    {
      title: "Improvements",
      descriptions: [
        "Live Trend Charts\nRealtime updates every second\nCustomizable line width and color\nPlease contact JRCS for more information",
      ],
      images: [
        require('./images/v12-0-0_fig6.png').default,
      ],
    }
  ],
  [
    {
      releaseDate: "2026-02-24T16:00",
      updatedDate: "2026-02-24T16:00",
      version: "11.0.1",
      introduction: "We are constantly working to improve your experience with our infoceanus tools. Here is a summary of some of our newest changes to connect:",
      conclusion: "We always value your feedback. If you have any suggestions for improvement or other feedback for our infoceanus tools, please send us an email at connect-support@jrcs.co.jp. Happy sailing!"
    },
    {
      title: "Improvements",
      descriptions: [
        "Every new version of Service agreement will now require a user confirmation. This confirmation persists irrespective of browser used.",
        "Updated Vessel Overview for small screen displays (mobile phone, tablet, etc.)",
      ],
      images: [],
    }
  ],
  [
    {
      releaseDate: "2025-09-18T16:00",
      updatedDate: "2025-09-18T16:00",
      version: "11.0.0",
      introduction: "We are constantly working to improve your experience with our infoceanus tools. Here is a summary of some of our newest changes to connect:",
      conclusion: "We always value your feedback. If you have any suggestions for improvement or other feedback for our infoceanus tools, please send us an email at connect-support@jrcs.co.jp. Happy sailing!"
    },
    {
      title: "New features",
      descriptions: [
        "NEW! Custom Channel Groups\nUp to 15 custom groups can be added per vessel",
        "NEW! Digital Channel step up chart on Trend Data Page\nNew design for Digital channel graphs, Analog + Digital graphs"
      ],
      images: [
        require('./images/v11-0-0_fig1.png').default,
        require('./images/v11-0-0_fig2.png').default,
        require('./images/v11-0-0_fig3.png').default,
        require('./images/v11-0-0_fig4.png').default,
      ],
    },
    {
      title: "Improvements",
      descriptions: [
        "Additional custom graphs can be created on Trend Data Page\nUp to 16 custom graphs can now be added per vessel",
        "Additional channels can be created on Custom Graphs (Trend Data Page)\nUp to 36 channels can now be added per custom graph",
        "Graph Variables design changes on Trend Data Page \nGraph Variables are now on the right side of the graph\nText size is BIGGER\nCorresponding data is displayed on the right side of Graph Variable when hovering on graph, data display will be locked when graph is clicked\nHover selection design is updated to a simple Underline",
        "Tooltip design updates on Trend Data Page and Data Comparison Page\nTooltip on graph hover is now at the bottom part of the graph\nTooltip information display on graph hover is changed to date and time",
        "Up to 4 custom graphs to compare on Data Comparison Page",
        "Trend Graph Page graphs: X-axis and Y-axis can now be controlled by keyboard"
      ],
      images: [],
    }
  ],
  [
    {
      releaseDate: "2025-08-28T16:00",
      updatedDate: "2025-08-28T16:00",
      version: "10.2.8",
      introduction: "We are constantly working to improve your experience with our infoceanus tools. Here is a summary of some of our newest changes to connect:",
      conclusion: "We always value your feedback. If you have any suggestions for improvement or other feedback for our infoceanus tools, please send us an email at connect-support@jrcs.co.jp. Happy sailing!"
    },
    {
      title: "Improvements",
      descriptions: [
        "Improved CSV download on Custom Trend Graphs",
      ],
      images: [],
    }
  ],
  [
    {
      startDate: "2025-07-29T15:00:00",
      endDate: "2025-07-29T17:00:00",
      updatedDate: "2025-07-28T15:00:00",
      introduction: "To further enhance your experience with Infoceanus, we’ll be performing a background update tomorrow, 07/29, from 15:00 to 17:00 JST. This update is designed to be seamless, and no disruption to your usage is expected. ",
      conclusion: "Please continue using Connect as usual during this time. If you happen to encounter any issues, feel free to reach out to us immediately at connect-support@jrcs.co.jp — we’ll investigate promptly and follow-up with you as soon as possible. Thank you for your continued cooperation and support as we work to deliver an even better experience. Happy sailing!",
    },
  ],
  [
    {
      releaseDate: "2025-02-20T17:00:00",
      updatedDate: "2025-02-20T17:00:00",
      version: "10.2.7",
      introduction: "We are constantly working to improve your experience with our infoceanus tools. Here is a summary of some of our newest changes to connect:",
      conclusion: "We always value your feedback. If you have any suggestions for improvement or other feedback for our infoceanus tools, please send us an email at connect-support@jrcs.co.jp. Happy sailing!",
    },
    {
      title: "Improvements",
      descriptions: [
        "Updated display of Navigation Data and Compass on Navigation Data Page and Cargo Tank Page"
      ],
      images: [],
    },
  ],
  [
    {
      releaseDate: "2025-01-28T16:00:00",
      updatedDate: "2025-01-28T16:00:00",
      version: "10.2.6",
      introduction: "We are constantly working to improve your experience with our infoceanus tools. Here is a summary of some of our newest changes to connect:",
      conclusion: "We always value your feedback. If you have any suggestions for improvement or other feedback for our infoceanus tools, please send us an email at connect-support@jrcs.co.jp. Happy sailing!",
    },
    {
      title: "Improvements",
      descriptions: [
        "Updated date timezone format on CSV file."
      ],
      images: [],
    },
  ],
  [
    {
      releaseDate: "2025-01-17T16:00:00",
      updatedDate: "2025-01-17T16:00:00",
      version: "10.2.5",
      introduction: "We are constantly working to improve your experience with our infoceanus tools. Here is a summary of some of our newest changes to connect:",
      conclusion: "We always value your feedback. If you have any suggestions for improvement or other feedback for our infoceanus tools, please send us an email at connect-support@jrcs.co.jp. Happy sailing!",
    },
    {
      title: "Improvements",
      descriptions: [
        "Updated release date format and Release Title for JP language.",
      ],
      images: [],
    },
  ],
  [
    {
      releaseDate: "2025-01-16T16:00:00",
      updatedDate: "2025-01-16T16:00:00",
      version: "10.2.4",
      introduction: "We are constantly working to improve your experience with our infoceanus tools. Here is a summary of some of our newest changes to connect:",
      conclusion: "We always value your feedback. If you have any suggestions for improvement or other feedback for our infoceanus tools, please send us an email at connect-support@jrcs.co.jp. Happy sailing!",
    },
    {
      title: "New features",
      descriptions: [
        "Release Notes page with version updates and history.",
        "Y-axis implementation on Custom Trend Graph for mixed data (analog and digital channels).",
      ],
      images: [require("./images/v10-2-4_fig1.png").default,],
    },
    {
      title: "Improvements",
      descriptions: [
        "Custom Graph chart display improvements on vessel switch via header selector.",
      ],
      images: [],
    },
  ],
  [
    {
      releaseDate: "2024-12-25T16:00:00",
      updatedDate: "2024-12-25T16:00:00",
      version: "10.2.3",
      introduction: "We are constantly working to improve your experience with our infoceanus tools. Here is a summary of some of our newest changes to connect:",
      conclusion: "We always value your feedback. If you have any suggestions for improvement or other feedback for our infoceanus tools, please send us an email at connect-support@jrcs.co.jp. Happy sailing!",
    },
    {
      title: "Improvements",
      descriptions: [
        "Improved performance on Graph zooming in and out for graphs with both Digital and Analog channel data.",
        "Improved display on Custom Trend Graph for all Digital channel data.",
      ],
      images: [],
    },
  ],
  [
    {
      releaseDate: "2024-12-19T16:00:00",
      updatedDate: "2024-12-19T16:00:00",
      version: "10.2.2",
      introduction: "We are constantly working to improve your experience with our infoceanus tools. Here is a summary of some of our newest changes to connect:",
      conclusion: "We always value your feedback. If you have any suggestions for improvement or other feedback for our infoceanus tools, please send us an email at connect-support@jrcs.co.jp. Happy sailing!",
    },
    {
      title: "Improvements",
      descriptions: [
        "Minor fix on engine data from v10.2.1.",
      ],
      images: [],
    },
  ],
  [
    {
      releaseDate: "2024-12-19T16:00:00",
      updatedDate: "2024-12-19T16:00:00",
      version: "10.2.1",
      introduction: "We are constantly working to improve your experience with our infoceanus tools. Here is a summary of some of our newest changes to connect:",
      conclusion: "We always value your feedback. If you have any suggestions for improvement or other feedback for our infoceanus tools, please send us an email at connect-support@jrcs.co.jp. Happy sailing!",
    },
    {
      title: "Improvements",
      descriptions: [
        "Custom trend graph display update to make all available channel types visible on Chart.",
        "Edit custom chart display improvement.",
        "Added custom graph loading icon.",
        "Trend Graph downloaded CSV file can now be downloaded on UTC and Local Time (JST) format.",
      ],
      images: [],
    },
  ],
  [
    {
      releaseDate: "2024-12-17T16:00:00",
      updatedDate: "2024-12-17T16:00:00",
      version: "10.2.0",
      introduction: "We are constantly working to improve your experience with our infoceanus tools. Here is a summary of some of our newest changes to connect:",
      conclusion: "We always value your feedback. If you have any suggestions for improvement or other feedback for our infoceanus tools, please send us an email at connect-support@jrcs.co.jp. Happy sailing!",
    },
    {
      title: "New features",
      descriptions: [
        "NEW! Multiple Fleet View per user configuration.",
        'NEW! Vessel parameters for Generator Fuel Oil Consumption:\nAdded fuel unit "KG", "TON", “GAL”.',
        "NEW Design for Channel Threshold Notification.",
        "NEW! Timezone picker in Header:\nChoose between UTC and LT (Local Time).\nTrend Graph DateTime display and download is based on the set Timezone on Header.",
        "Navigation Data Page NEW Design for True Wind and Relative Wind display.",
      ],
      images: [],
    },
    {
      title: "Improvements",
      descriptions: [
        "Performance Improvements:\nChannel Page data loading and response time for each vessel.\nData Comparison Page response time improvement.\nTrend Graph display loading time improvement.",
        "Updated configuration for Vessel Online / Offline Alert Emails.",
        "Improved Deleting and Editing Custom Graph functionalities.",
        "Image download: Graph Snapshot filename now indicates timezone selected.",
        "Alarm Status and Alarm Data Overview Display improved.",
        "Improved data download on 1-sec data (for specific vessels only).",
        "Third-party user API Requests Rate Limit updated.",
      ],
      images: [],
    },
  ],
];